import { logger } from '@tuic/logger';
import { Account } from '../../index';

export const deleteAccount = async (
  args: Account.DeleteAccountRequest & { idToken: string },
): Promise<boolean> => {
  let { idToken, ...body } = args;

  let { data, error } = await Account.deleteAccount({
    body,
    auth: idToken,
  });

  if (error) {
    logger.error(`[Account] Failed deleting account. ${JSON.stringify(args)}`);
    logger.error(error);

    return false;
  }

  return data?.success ?? false;
};
